import React from 'react';
import { MapPinIcon, PhoneIcon, InstagramIcon, FacebookIcon, TwitterIcon, SparklesIcon } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gradient-to-r from-green-900 to-green-800 text-white py-16 relative overflow-hidden" data-id="element-30">
      <div className="absolute inset-0 opacity-10" data-id="element-31">
        <div className="absolute top-10 left-1/4 floating-slow" data-id="element-32">
          <SparklesIcon size={48} data-id="element-33" />
        </div>
        <div className="absolute bottom-20 right-1/3 floating" data-id="element-34">
          <SparklesIcon size={32} data-id="element-35" />
        </div>
        <div className="absolute top-1/2 right-1/4 floating-fast" data-id="element-36">
          <SparklesIcon size={24} data-id="element-37" />
        </div>
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-39">
          <div data-id="element-40">
            <h3 className="text-xl font-futuristic font-semibold mb-4" data-id="element-41">
              Ayira's Cafe
            </h3>
            <p className="mb-2" data-id="element-42">Kenya's First Neurodivergent Café</p>
            <p className="text-sm" data-id="element-43">
              "Simply Special. Rich in Taste, Rooted in Care."
            </p>
            <div className="flex space-x-4 mt-6" data-id="element-44">
              <a href="#" className="text-white/70 hover:text-white transition duration-300 hover:scale-110" data-id="element-45">
                <InstagramIcon size={20} data-id="element-46" />
              </a>
              <a href="#" className="text-white/70 hover:text-white transition duration-300 hover:scale-110" data-id="element-47">
                <FacebookIcon size={20} data-id="element-48" />
              </a>
              <a href="#" className="text-white/70 hover:text-white transition duration-300 hover:scale-110" data-id="element-49">
                <TwitterIcon size={20} data-id="element-50" />
              </a>
            </div>
          </div>
          <div data-id="element-51">
            <h3 className="text-xl font-futuristic font-semibold mb-4" data-id="element-52">
              Location
            </h3>
            <p className="flex items-start mb-4" data-id="element-53">
              <MapPinIcon size={20} className="mr-2 mt-1 flex-shrink-0" data-id="element-54" />
              <span data-id="element-55">
                Shiko Road, off Elgeyo Marakwet Road, Kilimani, Moi, Nairobi
                Area, Kenya
              </span>
            </p>
            <p className="flex items-center" data-id="element-56">
              <PhoneIcon size={20} className="mr-2 flex-shrink-0" data-id="element-57" />
              <a href="tel:+254746210909" className="hover:text-green-300 transition duration-300" data-id="element-58">
                +254 746 210909
              </a>
            </p>
          </div>
          <div data-id="element-59">
            <h3 className="text-xl font-futuristic font-semibold mb-4" data-id="element-60">
              Opening Hours
            </h3>
            <p className="mb-2" data-id="element-61">Monday - Friday: 8:00 AM - 8:00 PM</p>
            <p className="mb-2" data-id="element-62">Saturday: 9:00 AM - 9:00 PM</p>
            <p className="mb-6" data-id="element-63">Sunday: 10:00 AM - 6:00 PM</p>
            <div data-id="element-64">
              <a href="tel:+254746210909" className="inline-block btn-futuristic" data-id="element-65">
                Make a Reservation
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 mt-12 pt-8 text-center text-sm" data-id="element-66">
          <p data-id="element-67">
            &copy; {new Date().getFullYear()} Ayira's Cafe. All rights reserved.
          </p>
          <p className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-68">
            <span className="px-3 py-1 bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-300" data-id="element-69">
              #Neurodiversity
            </span>
            <span className="px-3 py-1 bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-300" data-id="element-70">
              #SimplySpecial
            </span>
            <span className="px-3 py-1 bg-white/10 rounded-full hover:bg-white/20 transition-colors duration-300" data-id="element-71">
              #AyirasCafe
            </span>
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;